<template>
  <b-row>
    <b-col cols="12">
      <b-form-group>
        <v-select 
          v-if="categories!=null"
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          :options="categories" 
          multiple
          class="select-size-lg modern-select"
          :placeholder="$t('Select groups...')"
        >
          <template #open-indicator="{ attributes }">
            <feather-icon v-bind="attributes" icon="ChevronDownIcon" size="18" />
          </template>
          
          <template #header>
            <div class="d-flex justify-content-between align-items-center px-2 py-1 border-bottom" 
                 v-if="categories && categories.length > 0">
              <small class="text-muted">
                {{ selected ? selected.length : 0 }} / {{ categories.length }} {{ $t('selected') }}
              </small>
              <a href="javascript:void(0)" 
                 @click="toggleSelectAll"
                 class="text-primary"
                 style="font-size: 0.875rem;">
                {{ isAllSelected ? $t('Clear all') : $t('Select all') }}
              </a>
            </div>
          </template>
          
          <template #no-options>
            <div class="text-center py-2">
              <feather-icon icon="LayersIcon" size="24" class="text-muted mb-1" />
              <p class="text-muted mb-0">{{ $t('No groups available') }}</p>
            </div>
          </template>
          
          <template #option="{ name }">
            <div class="d-flex align-items-center py-1">
              <div class="group-icon-wrapper mr-2">
                <feather-icon icon="LayersIcon" size="18" />
              </div>
              <span class="font-weight-medium">{{ name }}</span>
            </div>
          </template>
          
          <template #selected-option="{ name }">
            <div class="d-flex align-items-center">
              <feather-icon icon="LayersIcon" size="14" class="mr-1" />
              <span>{{ name }}</span>
            </div>
          </template>
        </v-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  created () {
    this.fetchCategories()
  
  },
  props :{
    initialCategories:[]
  },

  computed: {
    isAllSelected() {
      return this.categories && this.selected && 
             this.categories.length > 0 && 
             this.selected.length === this.categories.length
    }
  },
  methods:{
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selected = []
      } else {
        this.selected = [...this.categories]
      }
    },
     updateSelections(a) {
    //console.log(a)
  },
         fetchCategories( ) {
   //   //console.log("fetchCategories fetch");
      return new Promise((resolve, reject) => {
        axios
          .get('/admin/f/cm/getgroups' )
          .then((response)=> { 
           var data=  response.data;
           var responseData=JSON.parse(  JSON.stringify( data));
    //      //console.log(responseData.data);
              this.categories=responseData.data;
            }
            )
          .catch(error => reject(error))
      })
    },
  },
  watch: {
  selected: function (newVal,coldVal) {

     this.$emit("selectionChanged", newVal);
  }
},
  data() {
    return {
      categories:null,
      selected: this.initialCategories,
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  }
   

}
</script>

<style lang="scss" scoped>
.modern-select {
  ::v-deep {
    .vs__dropdown-toggle {
      border: 2px solid #e8e8e8;
      border-radius: 8px;
      padding: 8px 12px;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
      
      &:hover {
        border-color: #7367f0;
        box-shadow: 0 4px 8px rgba(115, 103, 240, 0.1);
      }
    }
    
    .vs__dropdown-toggle--focused {
      border-color: #7367f0 !important;
      box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.1);
    }
    
    .vs__search {
      font-size: 1rem;
      padding: 4px 0;
      
      &::placeholder {
        color: #b4b4b4;
      }
    }
    
    .vs__dropdown-menu {
      border: 2px solid #e8e8e8;
      border-radius: 8px;
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
      margin-top: 8px;
      max-height: 320px !important;
      overflow-y: auto;
      animation: slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      transform-origin: top;
      will-change: transform, opacity;
      
      // Custom scrollbar
      &::-webkit-scrollbar {
        width: 8px;
      }
      
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 0 8px 8px 0;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #7367f0;
        border-radius: 4px;
        
        &:hover {
          background: #5e50ee;
        }
      }
    }
    
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-10px) scaleY(0.95);
      }
      to {
        opacity: 1;
        transform: translateY(0) scaleY(1);
      }
    }
    
    .vs__dropdown-option {
      padding: 8px 12px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      
      &--highlight {
        background: linear-gradient(118deg, rgba(115, 103, 240, 0.1), rgba(115, 103, 240, 0.05));
        color: #7367f0;
      }
      
      &:hover {
        transform: translateX(4px);
      }
    }
    
    .vs__selected {
      margin: 2px;
      padding: 4px 8px;
      border-radius: 6px;
      background-color: #7367f0;
      color: white;
      border: none;
    }
    
    .vs__deselect {
      fill: white;
    }
    
    .vs__clear {
      margin-right: 4px;
    }
    
    .vs__open-indicator {
      fill: #7367f0;
      transition: transform 0.3s ease;
    }
    
    .vs__dropdown-toggle--open .vs__open-indicator {
      transform: rotate(180deg);
    }
  }
}

.group-icon-wrapper {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: #f0efff;
  color: #7367f0;
}
</style>